import { memo } from "react";
import classes from "./CircularLoadingSpinner.module.scss";

export interface CircularLoadingSpinnerProps {
  size?: "medium" | "large" | string;
  fillWidth?: boolean;
}

export const CircularLoadingSpinner = memo(function CircularLoadingSpinner({
  size = "medium",
  fillWidth = false,
}: CircularLoadingSpinnerProps) {
  if (!fillWidth) {
    return <CircularLoadingSpinnerContent size={size} />;
  }

  return (
    <div
      style={{
        width: "100%",
        padding: "1em 0",
      }}
    >
      <div
        style={{
          width: "fit-content",
          margin: "0 auto",
        }}
      >
        <CircularLoadingSpinnerContent size={size} />
      </div>
    </div>
  );
});

function CircularLoadingSpinnerContent({
  size,
}: Required<Omit<CircularLoadingSpinnerProps, "fillWidth">>) {
  const spinnerSize = (() => {
    switch (size) {
      case "medium":
        return "20px";
      case "large":
        return "35px";
      default:
        return size;
    }
  })();

  return (
    <div
      className={classes.spinner}
      style={{
        "--spinner-size": spinnerSize,
        width: spinnerSize,
      }}
    >
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className={classes.blade}></div>
      ))}
    </div>
  );
}
